// frontend/src/components/demo/DemoLanding.tsx
// Entry modal shown on first visit to demo.stagewise.app.
// Launches an isolated ephemeral demo session for the visitor.
import { useState } from 'react'
import useAuthStore from '../../store/authStore.js'
import { useLanguage } from '../../i18n/index.jsx'
import { getAppDomain } from '../../lib/appDomain.js'

// Only show on the demo subdomain and only on first visit (localStorage flag not set).
export default function DemoLanding() {
  const { t }     = useLanguage()
  const user      = useAuthStore(s => s.user)
  const startDemo = useAuthStore(s => s.startDemo)

  const [loading, setLoading] = useState(false)

  const HOST_DOMAIN = getAppDomain()
  const isDemoHost  = window.location.hostname === `demo.${HOST_DOMAIN}`
  const entrySeen   = !!localStorage.getItem('sw_demo_entry_seen')
  const shouldShow  = !user && isDemoHost && !entrySeen

  if (!shouldShow) return null

  async function handleTry() {
    setLoading(true)
    try {
      await startDemo()
      localStorage.setItem('sw_demo_entry_seen', '1')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(10,14,20,0.85)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <div style={{
        background: 'var(--color-surface, #1e1e2e)',
        border: '1px solid var(--color-border, #333)',
        borderRadius: '1rem', padding: '2rem', maxWidth: '480px', width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <h2 style={{ marginBottom: '0.5rem', color: 'var(--color-text, #eee)', fontSize: '1.5rem', fontWeight: 700 }}>
          Welcome to Brighella
        </h2>
        <p style={{ color: 'var(--color-text-muted, #888)', marginBottom: '1.5rem', fontSize: '0.95rem' }}>
          {t('demoTryDescription')}
        </p>

        <button
          onClick={handleTry}
          disabled={loading}
          style={{
            width: '100%', textAlign: 'left', padding: '1.25rem', borderRadius: '0.75rem',
            border: '2px solid var(--color-primary, #7c3aed)',
            background: 'var(--color-primary-muted, rgba(124,58,237,0.1))',
            cursor: loading ? 'wait' : 'pointer',
            transition: 'all 0.15s',
          }}
        >
          <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🚀</div>
          <div style={{ fontWeight: 700, color: 'var(--color-primary, #7c3aed)', marginBottom: '0.4rem' }}>
            {loading ? t('demoSwitchingRole') : t('demoTryItYourself')}
          </div>
          <div style={{ fontSize: '0.8rem', color: 'var(--color-text-muted, #888)' }}>
            {t('demoTryDescriptionSub')}
          </div>
        </button>
      </div>
    </div>
  )
}
